<template>
	<vx-card class="stages-files">
		<div class="stages-files__title mb-3">
			<b>{{ $t("filesFromAuthor") }}</b>
		</div>

		<div class="stages-files__list">
			<div v-for="stage in validStages" :key="stage.index" class="stage">
				<div
					class="stage__head flex justify-between items-center flex-wrap"
				>
					<div class="stage__name">
						{{ $t("stage") }} {{ stage.index }}
					</div>

					<div
						v-if="
							stage &&
								currentStage &&
								stage.id === currentStage.id
						"
						class="stage__send"
					>
						<template>
							<vs-button
								v-if="!isSendClicked"
								class="stage__send-btn"
								color="success"
								@click="sendStageFiles(stage)"
							>
								{{ $t("send") }}
							</vs-button>

							<vs-button
								v-else
								disabled
								class="stage__send-btn"
								color="success"
							>
								{{ $t("send") }}
							</vs-button>
						</template>
					</div>
				</div>

				<div class="vx-row">
					<div
						v-for="(file, fileIndex) in stage.files"
						:key="fileIndex"
						class="vx-col flex column stage__file"
					>
						<div
							class="stage__file-container"
							@click="e => openImagePopup(e, file)"
						>
							<FileNameView
								:orderId="orderId"
								:url="file.url"
								@fileDeleted="updateModel"
							/>

							<FileNameView
								v-if="file.report_file_plag_scan !== null"
								:isReportFile="true"
								:url="file.report_file_plag_scan"
								:orderId="orderId"
							/>

							<vs-button
								v-if="showCheckFileButton(file, stage)"
								:disabled="
									loading || orderStatus === 'completed'
								"
								class="stage__send-btn"
								color="primary"
								@click="checkOrderFile(file)"
							>
								{{ $t("check") }}
							</vs-button>
						</div>

						<div v-if="file.percent_plagiat !== null">
							{{ $t("plagiatPercentage") }} -
							{{ file.percent_plagiat + " %" }}
						</div>
						<div v-if="file.percent_ai !== null">
							<div v-for="(aiService, i) in file.percent_ai">
								{{ aiService.label }}
								<vs-alert v-if="aiService.error" color="danger" class="mb-2">{{ aiService.error }}</vs-alert>
							</div>
						</div>
					</div>
				</div>

				<div
					v-if="stage.wordsActual && stage.wordsExpected"
					class="vx-row"
				>
					<span class="vx-col h5">{{ $t("wordsCount") }}:</span>

					<div>
						<span>
							{{ stage.wordsActual }}
						</span>
						/
						<span>
							{{ stage.wordsExpected }}
						</span>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="stages-files__auto-sending">
			<vs-checkbox
				v-model="autoSending"
			>{{ $t('sendAutomatically') }}</vs-checkbox>
		</div> -->
	</vx-card>
</template>

<script>
import FileNameView from "@/views/Tickets/FileNameView";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "StagesFiles",
	mixins: [databaseManager, notifier],
	components: {
		FileNameView
	},

	props: {
		orderId: { type: Number },
		stages: { required: true, type: Array },
		sending: { type: Boolean },
		orderStatus: { type: String, default: "" }
	},

	data() {
		return {
			isSendClicked: false,
			imagePopupActive: false,
			imagePopupFile: null,
			loading: false
		};
	},

	watch: {
		autoSending() {
			this.setAutoSendFiles();
		}
	},

	computed: {
		autoSending: {
			get() {
				return this.sending;
			},
			set(value) {
				this.$emit("update:sending", value);
			}
		},

		validStages() {
			const handled = this.stages.map((item, index) => {
				return {
					id: item.id,
					index: index + 1,
					files: item.files,
					wordsActual: item.words_actual,
					wordsExpected: item.words_expected
				};
			});

			return handled.filter(
				item => item.files && item.files.length !== 0
			);
		},

		currentStage() {
			const current = this.stages.find(
				item => item.status !== "completed"
			);
			return current !== -1 ? current : null;
		}
	},

	methods: {
		async checkOrderFile(file) {
			try {
				this.loading = true;
				await this.dbCheckOrderFile(file.id);
				this.notifySuccess(
					this.$t("fileWillBeCheckedAsSoonAsPossible")
				);
				this.$set(file, "status", "need_check");
			} catch (err) {
				this.notifyError(err.message);
			} finally {
				this.loading = false;
			}
		},

		showCheckFileButton(file, stage) {
			const fileIdx = this.validStages.findIndex(
				el => el.id === stage.id
			);
			const isLastStage = this.stages.length === fileIdx + 1;

			return file.status === "no_need_to_check" && isLastStage;
		},

		openImagePopup(e, file) {
			this.$emit("openImagePopup", e, file);
		},

		async updateModel() {
			this.$emit("updateModel");
		},

		async setAutoSendFiles() {
			try {
				await this.dbSetAutoSendFiles(this.orderId, this.autoSending);
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async sendStageFiles(stage) {
			this.isSendClicked = true;

			try {
				await this.dbSendStageFiles(stage.id);
				this.notifySuccess(this.$t("filesWasSentToClient"));
			} catch (e) {
				this.notifyError(e.message);
			}

			this.isSendClicked = false;
		}
	}
};
</script>

<style lang="scss">
.stages-files {
	margin-top: 20px;

	&__list {
		display: grid;
		grid-row-gap: 10px;

		.stage {
			padding-top: 15px;
			padding-bottom: 15px;
			border-top: #e4e4e4 1px solid;
			min-width: 0;

			.fileName {
				margin-right: 0;
				max-width: fit-content;
			}

			&:first-child {
				border-top: none;
				padding-top: 5px;
			}

			&__file {
				margin-top: 10px;
				width: 100%;

				&-container {
					display: flex;
					align-items: center;
          justify-content: space-between;
					flex-wrap: wrap;
					grid-gap: 10px;
					margin-bottom: 5px;
				}
			}

			&__send-btn {
				padding: 7px 10px !important;
			}
		}
	}

	&__auto-sending {
		border-top: #e4e4e4 1px solid;
		padding-top: 15px;
	}
}
</style>
